import { render, staticRenderFns } from "./MigrationsList.vue?vue&type=template&id=0d000b2d&"
import script from "./MigrationsList.vue?vue&type=script&lang=js&"
export * from "./MigrationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d000b2d')) {
      api.createRecord('0d000b2d', component.options)
    } else {
      api.reload('0d000b2d', component.options)
    }
    module.hot.accept("./MigrationsList.vue?vue&type=template&id=0d000b2d&", function () {
      api.rerender('0d000b2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Migrations/MigrationsList.vue"
export default component.exports